import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Button,
  Typography,
  Divider,
  Box,
  FormControl,
  ListSubheader,
  MenuItem,
  Checkbox,
  ListItemText,
  Chip,
  IconButton,
  InputLabel,
  Select,
  Modal,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import api from "../axiosConfig";
import axios from "axios";
import "../App.css";
import { format } from "date-fns";
import debounce from "lodash.debounce";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import ModalComp from "../themes/Model";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";

const Usermaster = ({ open }) => {
  const [data, setData] = useState([]);
  const [dummyState, setDummyState] = useState(0);

  const [selectedRow, setSelectedRow] = useState(null);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [warehouses, setWarehouses] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categorylist, setCategorylist] = useState([]);
  const [channels, setChannels] = useState([]);
  const [products, setProducts] = useState([]);

  const [selectedWarehouse, setSelectedWarehouse] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [selectedCategorylist, setSelectedCategorylist] = useState([]);
  const [selectedPagePremises, setSelectedPagePremises] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [openNotification, setNotification] = useState(false);
  const [openNotificationText, setNotificationText] = useState("");

  const [modalformData, modalsetFormData] = useState({
    userName: "",
    email: "",
    warehouse: [],
    channel: [],
    pricelist: [],
    product: [],
    pagePremises: [],
    status: "",
    categorylist: [],
  });

  const pagePremises = [
    "Summary",
    "Test Summary",
    "View/Edit Summary",
    "Edit Current Month",
    "Future Future Month",
    "User Master",
  ];

  useEffect(() => {
    api
      .get("/userMasterData")
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });

    api
      .get("/warehouses")
      .then((response) => setWarehouses(response.data || []))
      .catch((error) => console.error("Error fetching warehouses:", error));

    api
      .get("/channels")
      .then((response) => setChannels(response.data || []))
      .catch((error) => console.error("Error fetching channels:", error));

    api
      .get("/pricelist")
      .then((response) => setCategories(response.data || []))
      .catch((error) => console.error("Error fetching categories:", error));

    api
      .get("/products")
      .then((response) => setProducts(response.data || []))
      .catch((error) => console.error("Error fetching products:", error));

    api
      .get("/categorywithname")
      .then((response) => setCategorylist(response.data || []))
      .catch((error) => console.error("Error fetching products:", error));
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredWarehouses = warehouses.filter((warehouse) =>
    warehouse.Warehouse.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredChannels = channels.filter((channel) =>
    channel.Channel.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const filteredCategory = categories.filter((category) =>
    category.Pricelist.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const filteredCategorylist = categorylist.filter((item) =>
    item.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredPagePremises = pagePremises.filter((item) =>
    item.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    modalsetFormData({ ...modalformData, [name]: value });
  };

  // Open the modal with selected row data
  const handleEdit = (row) => {
    setSelectedRow(row);

    // Only split if the value is not null, undefined, or an empty string
    const warehouseArray = row.warehouse ? row.warehouse.split(",") : [];
    const channelArray = row.Channel ? row.Channel.split(",") : [];
    const pricelistArray = row.Pricelist ? row.Pricelist.split(",") : [];
    const categorylistArray = row.Category ? row.Category.split(",") : [];
    const pagepromiseArray = row.Page_Permission
      ? row.Page_Permission.split(",")
      : [];

    // Set state values after the split operation
    setSelectedWarehouse(warehouseArray);
    setSelectedChannel(channelArray);
    setSelectedCategorylist(categorylistArray);
    setSelectedCategory(pricelistArray);
    setSelectedPagePremises(pagepromiseArray);

    // Set modal form data
    modalsetFormData({
      userName: row.username || "",
      email: row.email || "",
      warehouse: warehouseArray,
      channel: channelArray,
      pricelist: pricelistArray,
      categories: categorylistArray,
      pagePremises: pagepromiseArray,
      status: row.Status !== null && row.Status !== undefined ? row.Status : "",
      categorylist: row.Categorylist || [],
    });

    setModalOpen(true);
  };

  const [errors, setErrors] = useState({});
  const validateForm = () => {
    const newErrors = {};

    if (!modalformData.userName.trim()) {
      newErrors.userName = "Username is required";
    }
    if (!modalformData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(modalformData.email)) {
      newErrors.email = "Enter a valid email address";
    }
    if (selectedWarehouse.length === 0) {
      newErrors.warehouse = "At least one warehouse must be selected";
    }
    if (selectedChannel.length === 0) {
      newErrors.channel = "At least one channel must be selected";
    }
    if (selectedCategory.length === 0) {
      newErrors.pricelist = "At least one price list must be selected";
    }
    if (selectedCategorylist.length === 0) {
      newErrors.categorylist = "At least one category list must be selected";
    }
    if (selectedPagePremises.length === 0) {
      newErrors.pagePremises = "At least page permises must be selected";
    }

    // Validate status
    if (modalformData.status !== 1 && modalformData.status !== 0) {
      newErrors.status = "Status must be Active or Inactive";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const response = await api.post("/addUserMaster", modalformData);

        if (response.data.Status === "true" && response.data.InsertedData) {
          // Standardize keys for table rendering
          const standardizedData = {
            ...response.data.InsertedData,
            Channel: response.data.InsertedData.channel,
            Pricelist: response.data.InsertedData.pricelist,
          };

          // Add the standardized data to state
          setData((prevData) => [...prevData, standardizedData]);

          setModalOpen(false);
          setNotification(false);
          setSelectedRow(null);
          console.log("User added successfully");

          // Reset the form data
          modalsetFormData({
            userName: "",
            email: "",
            warehouse: [],
            channel: [],
            pricelist: [],
            product: [],
            pagePremises: [],
            status: "",
            categorylist: [],
          });

          // Reset other form data variables
          setSelectedWarehouse([]);
          setSelectedChannel([]);
          setSelectedCategorylist([]);
          setSelectedCategory([]);
          setSelectedPagePremises([]);
        } else {
          throw new Error(response.data.Message || "Failed to add user.");
        }
      } catch (error) {
        console.error("Error:", error);
        setNotification(true);
        setNotificationText("Failed to add user.");
      }
    }
  };

  const handleUpdateSubmit = async () => {
    try {
      const updatedData = { ...modalformData, id: selectedRow.id };

      const response = await api.put("/updateUserMaster", updatedData);

      const updatedUser = response.data[0];
      if (updatedUser) {
        setData((prevData) =>
          prevData.map((row) =>
            row.id === updatedUser.id ? { ...row, ...updatedUser } : row
          )
        );

        console.log("Data Updated Successfully!");
        setModalOpen(false);
        setNotification(false);
        setSelectedRow(null);
        modalsetFormData({
          userName: "",
          email: "",
          warehouse: [],
          channel: [],
          pricelist: [],
          product: [],
          pagePremises: [],
          status: "",
          categorylist: [],
        });

        // Reset other form data variables
        setSelectedWarehouse([]);
        setSelectedChannel([]);
        setSelectedCategorylist([]);
        setSelectedCategory([]);
        setSelectedPagePremises([]);
      } else {
        console.error("No updated data returned from API response");
      }
    } catch (error) {
      console.error("Error updating user:", error);
      setNotificationText("Failed to update user.");
      setNotification(true);
    }
  };

  const handleWarehouseModalChange = (event) => {
    const {
      target: { value },
    } = event;

    if (value.includes("all")) {
      const allSelected = selectedWarehouse.length === warehouses.length;
      const newSelection = allSelected
        ? []
        : warehouses.map((w) => w.Warehouse);
      setSelectedWarehouse(newSelection);
      modalsetFormData((prevFormData) => ({
        ...prevFormData,
        warehouse: newSelection,
      }));
    } else {
      setSelectedWarehouse(value);
      modalsetFormData((prevFormData) => ({
        ...prevFormData,
        warehouse: value,
      }));
    }
  };

  const handleChannelModalChange = (event) => {
    const { value } = event.target;
    if (value.includes("all")) {
      const allSelected = selectedChannel.length === channels.length;
      const newSelection = allSelected ? [] : channels.map((c) => c.Channel);
      setSelectedChannel(newSelection);
      modalsetFormData((prev) => ({ ...prev, channel: newSelection }));
    } else {
      setSelectedChannel(value);
      modalsetFormData((prev) => ({ ...prev, channel: value }));
    }
  };

  const handleCategoryModalChange = (event) => {
    const { value } = event.target;
    if (value.includes("all")) {
      const allSelected = selectedCategory.length === categories.length;
      const newSelection = allSelected
        ? []
        : categories.map((p) => p.Pricelist);
      setSelectedCategory(newSelection);
      modalsetFormData((prev) => ({ ...prev, pricelist: newSelection }));
    } else {
      setSelectedCategory(value);
      modalsetFormData((prev) => ({ ...prev, pricelist: value }));
    }
  };

  const handleCategorylistModalChange = (event) => {
    const { value } = event.target;

    if (value.includes("all")) {
      const allSelected = selectedCategorylist.length === categorylist.length;
      const newSelection = allSelected
        ? []
        : categorylist.map((cl) => cl.category); // Convert to array of strings
      setSelectedCategorylist(newSelection);
      modalsetFormData((prev) => ({ ...prev, categorylist: newSelection }));
    } else {
      setSelectedCategorylist(value);
      modalsetFormData((prev) => ({ ...prev, categorylist: value }));
    }
  };

  // const handlePagePremiseChange = (event) => {
  //   const value = event.target.value;

  //   if (value.includes("all")) {
  //     const allSelected = selectedPagePremises.length === pagePremises.length;
  //     const newSelection = allSelected ? [] : pagePremises;
  //     setSelectedPagePremises(newSelection);
  //     modalsetFormData((prevFormData) => ({
  //       ...prevFormData,
  //       pagePremises: newSelection,
  //     }));
  //   } else {
  //     setSelectedPagePremises(value);
  //     modalsetFormData((prevFormData) => ({
  //       ...prevFormData,
  //       pagePremises: value,
  //     }));
  //   }
  // };

  const handlePagePremiseChange = (event, newValue) => {
    if (newValue.find((option) => option === "Select All")) {
      const allSelected = selectedPagePremises.length === pagePremises.length;
      const newSelection = allSelected ? [] : pagePremises;
      setSelectedPagePremises(newSelection);
      modalsetFormData((prevFormData) => ({
        ...prevFormData,
        pagePremises: newSelection,
      }));
    } else {
      setSelectedPagePremises(newValue);
      modalsetFormData((prevFormData) => ({
        ...prevFormData,
        pagePremises: newValue,
      }));
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedRow(null);
    modalsetFormData({
      userName: "",
      email: "",
      warehouse: [],
      channel: [],
      pricelist: [],
      product: [],
      pagePremises: [],
      status: 1,
      categorylist: [],
    });

    // Reset other form data variables
    setSelectedWarehouse([]);
    setSelectedChannel([]);
    setSelectedCategorylist([]);
    setSelectedCategory([]);
    setSelectedPagePremises([]);
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;

  const modalContent = (
    <>
      <Box
        sx={{
          bgcolor: "background.paper",
          maxWidth: 682,
          // maxHeight: "80vh",
          overflowY: "auto",
          mx: "auto",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="User Name"
              name="userName"
              value={modalformData.userName}
              onChange={handleChange}
              helperText={errors.userName}
              error={!!errors.userName}
              size="small"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              type="email"
              label="Email"
              name="email"
              value={modalformData.email}
              onChange={handleChange}
              required
              helperText={errors.email}
              error={!!errors.email}
              size="small"
            />
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth required error={!!errors.status}>
              <InputLabel
                sx={{
                  fontSize: "14px",
                  "&.MuiInputLabel-shrink": {
                    top: "1px", // When the label shrinks (focused or has a value)
                  },
                  "&:not(.MuiInputLabel-shrink)": {
                    top: "-4px", // Default position when inactive
                  },
                }}
              >
                Status
              </InputLabel>
              <Select
                name="status"
                value={modalformData.status}
                onChange={(e) => {
                  const value = e.target.value;
                  modalsetFormData((prevData) => ({
                    ...prevData,
                    status: value, // Directly update status with numeric value
                  }));
                }}
                label="Status"
                size="small"
              >
                <MenuItem value={1}>Active</MenuItem>
                <MenuItem value={0}>Inactive</MenuItem>
              </Select>
              <FormHelperText>{errors.status}</FormHelperText>
            </FormControl>
          </Grid>

          {/* warehouse */}
          {/* <Grid item xs={6}>
            <FormControl
              variant="outlined"
              style={{ minWidth: "200px", flexGrow: 1 }}
            >
              <InputLabel>Warehouse</InputLabel>
              <Select
                multiple
                value={selectedWarehouse}
                onChange={handleWarehouseModalChange}
                renderValue={(selected) => (
                  <Box display="flex" flexWrap="wrap" gap="8px">
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
              >
                <ListSubheader>
                  <Box padding="8px">
                    <TextField
                      placeholder="Search..."
                      fullWidth
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                  </Box>
                </ListSubheader>
                <MenuItem value="all">
                  <Checkbox
                    checked={selectedWarehouse.length === warehouses.length}
                    indeterminate={
                      selectedWarehouse.length > 0 &&
                      selectedWarehouse.length < warehouses.length
                    }
                  />
                  <ListItemText primary="Select All" />
                </MenuItem>
                List of Filtered Warehouses
                {filteredWarehouses.map((warehouse) => (
                  <MenuItem
                    key={warehouse.Warehouse}
                    value={warehouse.Warehouse}
                  >
                    <Checkbox
                      checked={selectedWarehouse.includes(warehouse.Warehouse)}
                    />
                    <ListItemText primary={warehouse.Warehouse} />
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{errors.warehouse}</FormHelperText>
            </FormControl>
          </Grid> */}

          {/* new warehouse */}
          <Grid item xs={6}>
            <FormControl
              variant="outlined"
              error={!!errors.warehouse}
              sx={{
                minWidth: 200,
                width: "100%",
                height: "50%",
                flexGrow: 1,
                border: "1px solid white",
                color: "white",
              }}
            >
              <Autocomplete
                multiple
                disableCloseOnSelect
                options={[{ Warehouse: "Select All" }, ...warehouses]}
                getOptionLabel={(option) => option.Warehouse}
                value={selectedWarehouse.map((warehouse) =>
                  warehouses.find((w) => w.Warehouse === warehouse)
                )}
                onChange={(event, newValue) => {
                  if (
                    newValue.some((option) => option.Warehouse === "Select All")
                  ) {
                    const allSelected =
                      selectedWarehouse.length === warehouses.length;
                    const newSelection = allSelected
                      ? []
                      : warehouses.map((w) => w.Warehouse);
                    setSelectedWarehouse(newSelection);
                    modalsetFormData((prev) => ({
                      ...prev,
                      warehouse: newSelection,
                    }));
                  } else {
                    const newSelection = newValue.map(
                      (option) => option.Warehouse
                    );
                    setSelectedWarehouse(newSelection);
                    modalsetFormData((prev) => ({
                      ...prev,
                      warehouse: newSelection,
                    }));
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Warehouse"
                    placeholder="Search..."
                    error={!!errors.warehouse}
                  />
                )}
                renderTags={(selected, getTagProps) => [
                  ...selected
                    .slice(0, 1)
                    .map((option, index) => (
                      <Chip
                        key={option.Warehouse}
                        label={option.Warehouse}
                        {...getTagProps({ index })}
                      />
                    )),
                  selected.length > 1 ? (
                    <Chip
                      key="more"
                      label={`+${selected.length - 1} more`}
                      sx={{
                        backgroundColor: "#149485",
                        color: "white",
                      }}
                    />
                  ) : null,
                ]}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      checked={
                        option.Warehouse === "Select All"
                          ? selectedWarehouse.length === warehouses.length
                          : selected
                      }
                      sx={{
                        color: "#149485",
                        "&.Mui-checked": {
                          color: "#149485",
                        },
                      }}
                    />
                    {option.Warehouse}
                  </li>
                )}
                sx={{
                  "& .MuiAutocomplete-tag": {
                    backgroundColor: "#149485",
                    color: "white",
                  },
                  "& .MuiInputBase-input": {
                    color: "black",
                    backgroundColor: "white",
                  },
                }}
                size="small"
              />
              {errors.warehouse && (
                <FormHelperText
                  sx={{
                    color: "#FF0000 !important",
                    marginTop: "4px !important",
                    marginLeft: "0",
                    marginRight: "0",
                  }}
                >
                  {errors.warehouse}*
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          {/* Channel */}
          {/* <Grid item xs={6}>
            <FormControl variant="outlined" style={{ minWidth: "200px" }}>
              <InputLabel>Channel</InputLabel>
              <Select
                multiple
                value={selectedChannel}
                onChange={handleChannelModalChange}
                renderValue={(selected) => (
                  <Box display="flex" flexWrap="wrap" gap="8px">
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
              >
                <ListSubheader>
                  <Box padding="8px">
                    <TextField
                      placeholder="Search..."
                      fullWidth
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                  </Box>
                </ListSubheader>
                <MenuItem value="all">
                  <Checkbox
                    checked={selectedChannel.length === channels.length}
                  />
                  <ListItemText primary="Select All" />
                </MenuItem>
                {filteredChannels.map((c) => (
                  <MenuItem key={c.Channel} value={c.Channel}>
                    <Checkbox checked={selectedChannel.includes(c.Channel)} />
                    <ListItemText primary={c.Channel} />
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{errors.channel}</FormHelperText>
            </FormControl>
          </Grid> */}

          {/* new Channel */}
          <Grid item xs={6}>
            <FormControl
              variant="outlined"
              error={!!errors.channel}
              style={{ width: "100%", flexGrow: 1 }}
            >
              <Autocomplete
                multiple
                disableCloseOnSelect
                options={[{ Channel: "Select All" }, ...channels]}
                getOptionLabel={(option) => option.Channel}
                value={selectedChannel.map((channel) =>
                  channels.find((c) => c.Channel === channel)
                )}
                onChange={(event, newValue) => {
                  if (
                    newValue.some((option) => option.Channel === "Select All")
                  ) {
                    const allSelected =
                      selectedChannel.length === channels.length;
                    const newSelection = allSelected
                      ? []
                      : channels.map((c) => c.Channel);
                    setSelectedChannel(newSelection);
                    modalsetFormData((prev) => ({
                      ...prev,
                      channel: newSelection,
                    }));
                  } else {
                    const newSelection = newValue.map(
                      (option) => option.Channel
                    );
                    setSelectedChannel(newSelection);
                    modalsetFormData((prev) => ({
                      ...prev,
                      channel: newSelection,
                    }));
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Channel"
                    placeholder="Search..."
                    fullWidth
                    error={!!errors.channel}
                  />
                )}
                renderTags={(selected, getTagProps) => [
                  ...selected
                    .slice(0, 1)
                    .map((option, index) => (
                      <Chip
                        key={option.Channel}
                        label={option.Channel}
                        {...getTagProps({ index })}
                      />
                    )),
                  selected.length > 1 ? (
                    <Chip
                      key="more"
                      label={`+${selected.length - 1} more`}
                      sx={{
                        backgroundColor: "#149485",
                        color: "white",
                      }}
                    />
                  ) : null,
                ]}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      checked={
                        option.Channel === "Select All"
                          ? selectedChannel.length === channels.length
                          : selected
                      }
                      sx={{
                        color: "#149485",
                        "&.Mui-checked": {
                          color: "#149485",
                        },
                      }}
                    />
                    {option.Channel}
                  </li>
                )}
                sx={{
                  "& .MuiAutocomplete-tag": {
                    backgroundColor: "#149485",
                    color: "white",
                  },
                }}
                size="small"
              />
              {errors.channel && (
                <FormHelperText
                  sx={{
                    color: "#FF0000 !important",
                    marginTop: "4px !important",
                    marginLeft: "0",
                    marginRight: "0",
                  }}
                >
                  {errors.channel}*
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          {/* Pricelist */}
          {/* <Grid item xs={6}>
            <FormControl variant="outlined" style={{ minWidth: "200px" }}>
              <InputLabel>Pricelist</InputLabel>
              <Select
                multiple
                value={selectedCategory}
                onChange={handleCategoryModalChange}
                renderValue={(selected) => (
                  <Box display="flex" flexWrap="wrap" gap="8px">
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
              >
                <ListSubheader>
                  <Box padding="8px">
                    <TextField
                      placeholder="Search..."
                      fullWidth
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                  </Box>
                </ListSubheader>
                <MenuItem value="all">
                  <Checkbox
                    checked={selectedCategory.length === categories.length}
                  />
                  <ListItemText primary="Select All" />
                </MenuItem>
                {filteredCategory.map((p) => (
                  <MenuItem key={p.Pricelist} value={p.Pricelist}>
                    <Checkbox
                      checked={selectedCategory.includes(p.Pricelist)}
                    />
                    <ListItemText primary={p.Pricelist} />
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{errors.pricelist}</FormHelperText>
            </FormControl>
          </Grid> */}

          {/* new Pricelist */}
          <Grid item xs={6}>
            <FormControl
              variant="outlined"
              error={!!errors.pricelist}
              style={{ width: "100%", flexGrow: 1 }}
            >
              <Autocomplete
                multiple
                disableCloseOnSelect
                options={[{ Pricelist: "Select All" }, ...categories]}
                getOptionLabel={(option) => option.Pricelist}
                value={selectedCategory.map((category) =>
                  categories.find((c) => c.Pricelist === category)
                )}
                onChange={(event, newValue) => {
                  if (
                    newValue.some((option) => option.Pricelist === "Select All")
                  ) {
                    const allSelected =
                      selectedCategory.length === categories.length;
                    const newSelection = allSelected
                      ? []
                      : categories.map((c) => c.Pricelist);
                    setSelectedCategory(newSelection);
                    modalsetFormData((prev) => ({
                      ...prev,
                      pricelist: newSelection,
                    }));
                  } else {
                    const newSelection = newValue.map(
                      (option) => option.Pricelist
                    );
                    setSelectedCategory(newSelection);
                    modalsetFormData((prev) => ({
                      ...prev,
                      pricelist: newSelection,
                    }));
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Pricelist"
                    placeholder="Search..."
                    fullWidth
                    error={!!errors.pricelist}
                  />
                )}
                renderTags={(selected, getTagProps) => [
                  ...selected
                    .slice(0, 1)
                    .map((option, index) => (
                      <Chip
                        key={option.Pricelist}
                        label={option.Pricelist}
                        {...getTagProps({ index })}
                      />
                    )),
                  selected.length > 1 ? (
                    <Chip
                      key="more"
                      label={`+${selected.length - 1} more`}
                      sx={{
                        backgroundColor: "#149485",
                        color: "white",
                      }}
                    />
                  ) : null,
                ]}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      checked={
                        option.Pricelist === "Select All"
                          ? selectedCategory.length === categories.length
                          : selected
                      }
                      sx={{
                        color: "#149485",
                        "&.Mui-checked": {
                          color: "#149485",
                        },
                      }}
                    />
                    {option.Pricelist}
                  </li>
                )}
                sx={{
                  "& .MuiAutocomplete-tag": {
                    backgroundColor: "#149485",
                    color: "white",
                  },
                }}
                size="small"
              />
              {errors.pricelist && (
                <FormHelperText
                  sx={{
                    color: "#FF0000 !important",
                    marginTop: "4px !important",
                    marginLeft: "0",
                    marginRight: "0",
                  }}
                >
                  {errors.pricelist}*
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          {/* Categorylist */}
          {/* <Grid item xs={6}>
            <FormControl variant="outlined" style={{ minWidth: "200px" }}>
              <InputLabel>Categorylist</InputLabel>
              <Select
                multiple
                value={selectedCategorylist} // Use as an array of strings
                onChange={handleCategorylistModalChange}
                renderValue={(selected) => (
                  <Box display="flex" flexWrap="wrap" gap="8px">
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
              >
                <ListSubheader>
                  <Box padding="8px">
                    <TextField
                      placeholder="Search..."
                      fullWidth
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                  </Box>
                </ListSubheader>
                <MenuItem value="all">
                  <Checkbox
                    checked={
                      selectedCategorylist.length === categorylist.length
                    }
                  />
                  <ListItemText primary="Select All" />
                </MenuItem>
                {filteredCategorylist.map((cl) => (
                  <MenuItem key={cl.category} value={cl.category}>
                    <Checkbox
                      checked={selectedCategorylist.includes(cl.category)}
                    />
                    <ListItemText primary={cl.category} />
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{errors.categorylist}</FormHelperText>
            </FormControl>
          </Grid> */}

          {/*New Categorylist */}

          <Grid item xs={6}>
            <FormControl
              variant="outlined"
              error={!!errors.categorylist}
              style={{ width: "100%", flexGrow: 1 }}
            >
              <Autocomplete
                multiple
                disableCloseOnSelect
                options={[{ category: "Select All" }, ...categorylist]} // Add "Select All" option
                getOptionLabel={(option) => option.category} // Use the correct property name
                value={selectedCategorylist.map((category) =>
                  categorylist.find((c) => c.category === category)
                )}
                onChange={(event, newValue) => {
                  // Handle "Select All" logic
                  if (
                    newValue.find((option) => option.category === "Select All")
                  ) {
                    if (selectedCategorylist.length === categorylist.length) {
                      // If "Select All" is already selected, clear all selections
                      handleCategorylistModalChange({ target: { value: [] } });
                    } else {
                      // Otherwise, select all categories
                      handleCategorylistModalChange({
                        target: { value: categorylist.map((c) => c.category) },
                      });
                    }
                  } else {
                    // Handle regular selection
                    handleCategorylistModalChange({
                      target: { value: newValue.map((c) => c.category) },
                    });
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Categorylist"
                    placeholder="Search..."
                    fullWidth
                    error={!!errors.categorylist}
                  />
                )}
                renderTags={(selected, getTagProps) => [
                  ...selected
                    .slice(0, 2)
                    .map((option, index) => (
                      <Chip
                        key={option.category}
                        label={option.category}
                        {...getTagProps({ index })}
                      />
                    )),
                  selected.length > 2 ? (
                    <Chip
                      key="more"
                      label={`+${selected.length - 2} more`}
                      sx={{
                        backgroundColor: "#149485",
                        color: "white",
                      }}
                    />
                  ) : null,
                ]}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      checked={
                        option.category === "Select All"
                          ? selectedCategorylist.length === categorylist.length
                          : selectedCategorylist.includes(option.category)
                      }
                      sx={{
                        color: "#149485",
                        "&.Mui-checked": {
                          color: "#149485",
                        },
                      }}
                    />
                    {option.category}
                  </li>
                )}
                sx={{
                  "& .MuiAutocomplete-tag": {
                    backgroundColor: "#149485",
                    color: "white",
                  },
                }}
                size="small"
              />
              {errors.categorylist && (
                <FormHelperText
                  sx={{
                    color: "#FF0000 !important",
                    marginTop: "4px !important",
                    marginLeft: "0",
                    marginRight: "0",
                  }}
                >
                  {errors.categorylist}*
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          {/* page premises */}
          {/* <Grid item xs={6}>
            <FormControl
              variant="outlined"
              style={{ minWidth: "200px", flexGrow: 1 }}
            >
              <InputLabel>Page Premises</InputLabel>
              <Select
                multiple
                value={selectedPagePremises}
                onChange={handlePagePremiseChange}
                renderValue={(selected) => (
                  <Box display="flex" flexWrap="wrap" gap="8px">
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
              >
                <ListSubheader>
                  <Box padding="8px">
                    <TextField
                      placeholder="Search..."
                      fullWidth
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                  </Box>
                </ListSubheader>

                <MenuItem value="all">
                  <Checkbox
                    checked={
                      selectedPagePremises.length === pagePremises.length
                    }
                    indeterminate={
                      selectedPagePremises.length > 0 &&
                      selectedPagePremises.length < pagePremises.length
                    }
                  />
                  <ListItemText primary="Select All" />
                </MenuItem>

                {filteredPagePremises.map((item) => (
                  <MenuItem key={item} value={item}>
                    <Checkbox checked={selectedPagePremises.includes(item)} />
                    <ListItemText primary={item} />
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{errors.pagePremises}</FormHelperText>
            </FormControl>
          </Grid> */}

          {/* new page premises */}
          <Grid item xs={6}>
            <FormControl
              variant="outlined"
              error={!!errors.pagePremises}
              style={{ width: "100%", flexGrow: 1 }}
            >
              <Autocomplete
                multiple
                disableCloseOnSelect
                options={["Select All", ...filteredPagePremises]} // Add "Select All" option
                value={selectedPagePremises}
                onChange={handlePagePremiseChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Page Premises"
                    placeholder="Search..."
                    fullWidth
                    value={searchTerm}
                    onChange={handleSearchChange}
                    error={!!errors.pagePremises}
                  />
                )}
                renderTags={(selected, getTagProps) => [
                  ...selected
                    .slice(0, 2)
                    .map((option, index) => (
                      <Chip
                        key={option}
                        label={option}
                        {...getTagProps({ index })}
                      />
                    )),
                  selected.length > 2 ? (
                    <Chip
                      key="more"
                      label={`+${selected.length - 2} more`}
                      sx={{
                        backgroundColor: "#149485",
                        color: "white",
                      }}
                    />
                  ) : null,
                ]}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      checked={
                        option === "Select All"
                          ? selectedPagePremises.length === pagePremises.length
                          : selected
                      }
                      indeterminate={
                        option === "Select All" &&
                        selectedPagePremises.length > 0 &&
                        selectedPagePremises.length < pagePremises.length
                      }
                      sx={{
                        color: "#149485",
                        "&.Mui-checked": {
                          color: "#149485",
                        },
                      }}
                    />
                    {option}
                  </li>
                )}
                sx={{
                  "& .MuiAutocomplete-tag": {
                    backgroundColor: "#149485",
                    color: "white",
                  },
                }}
                size="small"
              />
              {errors.pagePremises && (
                <FormHelperText
                  sx={{
                    color: "#FF0000 !important",
                    marginTop: "4px !important",
                    marginLeft: "0",
                    marginRight: "0",
                  }}
                >
                  {errors.pagePremises}*
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
        </Grid>
        <br></br>
        {openNotification && (
          <div>
            <h5 color="warning">{openNotificationText}</h5>
          </div>
        )}
      </Box>
    </>
  );

  // modal buttons
  const actionButtons = (
    <>
      <Box sx={{ mt: 3, textAlign: "right" }}>
        {/* Show Add button if selectedRow is null */}
        {selectedRow === null ? (
          <Button
            variant="contained"
            color="primary"
            onClick={handleCreateSubmit}
            sx={{
              fontSize: "12px",
              background: "#16a695",
            }}
            size="small"
          >
            <AddIcon
              sx={{
                fontSize: "13px",
                marginRight: "5px",
              }}
            />
            Add
          </Button>
        ) : (
          // Show Update button if selectedRow is not null
          <Button
            variant="contained"
            color="primary"
            onClick={handleUpdateSubmit}
            sx={{
              fontSize: "12px",
              background: "#16a695",
            }}
            size="small"
          >
            Update
          </Button>
        )}
        &nbsp;&nbsp;&nbsp;
        {/* Show Close button */}
        <Button
          variant="contained"
          color="primary"
          onClick={handleCloseModal}
          style={{
            fontSize: "12px",
            color: "#1A1A1A",
            border: "1px solid #707070",
            background: "#fff",
          }}
          size="small"
        >
          Close
        </Button>
      </Box>
    </>
  );

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <>
      <div style={{ marginLeft: open ? "240px" : "0px" }}>
        <Container maxWidth="lx">
          {/* ADD NEW BUTTON */}
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "20px",
              marginTop: "30px",
              padding: "0 15px",
            }}
          >
            &nbsp;&nbsp;&nbsp;
            <Button
              variant="outlined"
              color="primary"
              style={{
                fontSize: "12px",
                color: "#fff",
                borderColor: "#16a695",
                background: "#16a695",
              }}
              onClick={handleOpenModal}
              size="medium"
            >
              <AddIcon
                sx={{
                  marginRight: "5px",
                }}
              />{" "}
              Add User
            </Button>
          </Box>

          {/* TABLE CONTENT */}
          <Grid container>
            <Grid
              item
              sx={{
                padding: "15px 15px 40px 15px",
              }}
            >
              <Paper
                sx={{
                  padding: "0",
                }}
              >
                <TableContainer>
                  <Table
                    sx={{
                      "& .MuiTableCell-root": {
                        padding: "16px 14px",
                        fontSize: "14px", // Set font size for all table cells
                      },
                    }}
                  >
                    <TableHead
                      sx={{
                        backgroundColor: "#F4F4F4",
                        "& .MuiTableCell-root": {
                          fontSize: "13px",
                          fontWeight: 600,
                          color: "#000",
                          textAlign: "left",
                        },
                      }}
                    >
                      <TableRow>
                        <TableCell>Username</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Warehouse</TableCell>
                        <TableCell>Channel</TableCell>
                        <TableCell>Pricelist</TableCell>
                        <TableCell>Category</TableCell>
                        <TableCell>Page Permission</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {data.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>{row.username}</TableCell>
                          <TableCell>{row.email}</TableCell>
                          <TableCell>{row.warehouse}</TableCell>
                          <TableCell>{row.Channel}</TableCell>
                          <TableCell>{row.Pricelist}</TableCell>
                          <TableCell>{row.Category}</TableCell>
                          <TableCell>{row.Page_Permission}</TableCell>
                          <TableCell>{row.Status}</TableCell>
                          <TableCell>
                            <Button
                              variant="outlined"
                              style={{
                                fontSize: "12px",
                                color: "#1A1A1A",
                                border: "1px solid #707070",
                                background: "#fff",
                              }}
                              onClick={() => handleEdit(row)}
                              size="small"
                            >
                              <EditIcon
                                sx={{
                                  fontSize: "13px",
                                  marginRight: "5px",
                                }}
                              />
                              Edit
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </div>

      <ModalComp
        open={isModalOpen}
        // setCustomOpenModal={setCustomOpenModal}
        handleClose={handleClose}
        title={selectedRow === null ? "Add User" : "Update User"}
        modalContent={modalContent}
        modelButtons={actionButtons}
        datePickerStyle={{ width: "48%", margin: "5px" }}
        themeStyles={{
          boxStyle: {
            width: "682px",
            height: "auto",
            margin: "auto",
            marginTop: "80px",
          },
          titleStyle: {
            fontSize: "18px",
            fontWeight: 600,
            color: "#000",
            backgroundColor: "#F4F4F4",
            padding: "24px",
            position: "sticky",
            top: 0,
            zIndex: 10,
          },
          fieldStyle: { width: "100%", marginTop: "20px" },
          actionButtonContainerStyle: {
            padding: "0 20px 20px 20px",
          },
        }}
      />
    </>
  );
};

export default Usermaster;
